import { render, staticRenderFns } from "./memberbalance-lock-balance.vue?vue&type=template&id=312f7b16&"
import script from "./memberbalance-lock-balance.vue?vue&type=script&lang=js&"
export * from "./memberbalance-lock-balance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports